import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import OptionContractStep1 from './OptionContractStep1';
import OptionContractStep2 from './OptionContractStep2';
import OptionContractStep3 from './OptionContractStep3';
import OptionContractStep4 from './OptionContractStep4';
import OptionContractStep5 from './OptionContractStep5';
import OptionContractStep6 from './OptionContractStep6';
import Ty from './Ty';

const OptionContract = (props)=>{
	let basePath = "/contracts/free-contracts/option-contract";

	const meta = {
		title: "Option Contract",
		description: "It is an agreement between a buyer and seller that gives the purchaser of the option the right to buy a real property at a later date at an agreed upon price. This is done to bind the seller into selling the real property within a specific period of time. In Philippine jurisdiction, the option money does not form part of the purchase price."
	}

	return (
		<div className="page page-inner page-contract">
			<Meta {...meta}/>
				<div className="container-fluid">
					<div className="p-0">
						<div className="page-content py-3">

							<Switch>
								<Route path={basePath+"/1"} component={OptionContractStep1} />
								<Route path={basePath+"/2"} component={OptionContractStep2} />
								<Route path={basePath+"/3"} component={OptionContractStep3} />
								<Route path={basePath+"/4"} component={OptionContractStep4} />
								<Route path={basePath+"/5"} component={OptionContractStep5} />
								<Route path={basePath+"/6"} component={OptionContractStep6} />
								<Route path={basePath+"/ty"} component={Ty} />
								<Route component={DefaultView} />
							</Switch>

						</div>
					</div>
				</div>
			</div>
	);
}

export default OptionContract;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/option-contract/OptionContract.js